/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "../../../Common/Style/summaryStyle";
import GridEditRow from "../../../Common/GridEditRow/GridEditRow";
import _forEach from "lodash/forEach";
import Typography from "@mui/material/Typography";
import { momentToGermanDate } from "../../../../../services/formatService";
import { AbstractCase } from "../../../../../types/Entities/AbstractCase";
import { Box } from "@mui/material";

type AlimonyChildrenProps = {
  formData: AbstractCase | Record<string, any>;
  translate: Function;
  basePath: string;
};

const AlimonyChildren = ({ formData, translate, basePath }: AlimonyChildrenProps) => {
  if (formData.children && formData.children.length === 0) {
    return null;
  }

  const formPath = basePath + "/kinder";
  const section = "alimonyChildren";
  const ChildList = () => {
    let resultList: React.ReactNode[] = [];
    _forEach(formData.children, (child, index) => {
      resultList.push(
        <React.Fragment key={index}>
          <Grid item xs={12} sx={summaryStyle.question}>
            <Box id={`children[${index}].name`} sx={summaryStyle.scrollToAnchor} />
            {child.name} - geb: {momentToGermanDate(child.birthDate)}
          </Grid>
          <GridEditRow
            item
            xs={12}
            to={{
              pathname: formPath,
              state: {
                section: section,
                field: `children[${index}].name`,
              },
            }}
          >
            {translate(`children.childOf.${child.childOf}`, formData)}, Lebt bei {translate(`children.livesWith.${child.livesWith}`, formData)},
            Kindergeldempfänger: {translate(`children.childAllowanceReceiver.${child.childAllowanceReceiver}`, formData)}
          </GridEditRow>
        </React.Fragment>
      );
    });
    return <>{resultList}</>;
  };
  return (
    <>
      <Grid item xs={12} sx={summaryStyle.subHeadline}>
        <Typography variant={"h5"}>Kinder</Typography>
      </Grid>
      <ChildList />
    </>
  );
};

// @ts-ignore
export default AlimonyChildren;
